// custom.js
// Genera puntitos + flechas de navegación para el slider de imágenes de
// producto, sin modificar snippets/product-media-gallery.liquid.
// Las flechas solo se muestran en mobile (controlado por CSS).

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('media-gallery').forEach(initSliderNav);
});

function initSliderNav(mediaGallery) {
  const sliderComponent = mediaGallery.querySelector('slider-component');
  const slider = mediaGallery.querySelector('ul[id^="Slider-Gallery-"]');
  if (!slider || !sliderComponent) return;

  const slides = Array.from(slider.querySelectorAll(':scope > li.slider__slide'));
  if (slides.length < 2) return; // una sola imagen: no hace falta navegación extra

  if (slider.dataset.navInitialized) return; // evita duplicar si se re-ejecuta
  slider.dataset.navInitialized = 'true';

  let currentIndex = slides.findIndex(function (s) {
    return s.classList.contains('is-active');
  });
  if (currentIndex === -1) currentIndex = 0;

  // --- Puntitos ---
  const dotsContainer = document.createElement('div');
  dotsContainer.className = 'custom-slider-dots';

  const dots = slides.map(function (slide, index) {
    const dot = document.createElement('button');
    dot.type = 'button';
    dot.className = 'custom-slider-dots__dot';
    dot.setAttribute('aria-label', 'Ver imagen ' + (index + 1) + ' de ' + slides.length);
    if (index === currentIndex) dot.classList.add('is-active');
    dot.addEventListener('click', function () {
      goToSlide(index);
    });
    dotsContainer.appendChild(dot);
    return dot;
  });

  slider.insertAdjacentElement('afterend', dotsContainer);

  // --- Flechas (overlay sobre la imagen, solo visibles en mobile por CSS) ---
  sliderComponent.classList.add('custom-slider-arrows-wrapper');

  const prevArrow = document.createElement('button');
  prevArrow.type = 'button';
  prevArrow.className = 'custom-slider-arrow custom-slider-arrow--prev';
  prevArrow.setAttribute('aria-label', 'Imagen anterior');
  prevArrow.innerHTML = '&#8249;'; // ‹

  const nextArrow = document.createElement('button');
  nextArrow.type = 'button';
  nextArrow.className = 'custom-slider-arrow custom-slider-arrow--next';
  nextArrow.setAttribute('aria-label', 'Imagen siguiente');
  nextArrow.innerHTML = '&#8250;'; // ›

  prevArrow.addEventListener('click', function () {
    goToSlide(currentIndex - 1);
  });
  nextArrow.addEventListener('click', function () {
    goToSlide(currentIndex + 1);
  });

  sliderComponent.appendChild(prevArrow);
  sliderComponent.appendChild(nextArrow);

  function goToSlide(index) {
    const target = Math.max(0, Math.min(index, slides.length - 1));
    slides[target].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
  }

  function setActive(index) {
    currentIndex = index;
    dots.forEach(function (d) {
      d.classList.remove('is-active');
    });
    dots[index].classList.add('is-active');
  }

  // Detecta qué imagen está visible mientras el usuario hace swipe/scroll,
  // y actualiza el puntito activo + el índice usado por las flechas.
  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          const index = slides.indexOf(entry.target);
          if (index === -1) return;
          setActive(index);
        }
      });
    },
    {
      root: slider,
      threshold: 0.6,
    }
  );

  slides.forEach(function (slide) {
    observer.observe(slide);
  });
}

// Rotación de mensajes para la sección custom-announcement-bar.liquid
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.custom-announcement-bar__inner').forEach(initAnnouncementRotation);
});

function initAnnouncementRotation(container) {
  const messages = Array.from(container.querySelectorAll('.custom-announcement-bar__message'));
  if (messages.length < 2) return; // un solo mensaje: no hace falta rotar

  const autoplay = container.dataset.autoplay === 'true';
  const speed = parseInt(container.dataset.speed, 10) || 4000;
  if (!autoplay) return;

  let index = messages.findIndex(function (m) {
    return m.classList.contains('is-active');
  });
  if (index === -1) index = 0;

  setInterval(function () {
    messages[index].classList.remove('is-active');
    index = (index + 1) % messages.length;
    messages[index].classList.add('is-active');
  }, speed);
}

// Calcula el % de ahorro a partir del precio tachado y el precio de oferta,
// y lo inyecta como badge — sin tocar snippets/price.liquid.
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-price-landing .price__sale').forEach(initSavingsBadge);
});

function parsePrice(text) {
  // Extrae solo los dígitos (soporta formatos "Gs. 239.000" o "Gs. 239,000")
  const digits = text.replace(/[^\d]/g, '');
  return parseInt(digits, 10);
}

function initSavingsBadge(priceSale) {
  if (priceSale.dataset.badgeInitialized) return;
  priceSale.dataset.badgeInitialized = 'true';

  const regularEl = priceSale.querySelector('.price-item--regular');
  const saleEl = priceSale.querySelector('.price-item--sale');
  if (!regularEl || !saleEl) return;

  const regular = parsePrice(regularEl.textContent);
  const sale = parsePrice(saleEl.textContent);
  if (!regular || !sale || regular <= sale) return;

  const percent = Math.round(((regular - sale) / regular) * 100);

  const badge = document.createElement('span');
  badge.className = 'price-savings-badge';
  badge.textContent = '-' + percent + '%';
  priceSale.appendChild(badge);
}